import { Component, OnInit, Output, EventEmitter } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-china-captcha',
  templateUrl: './china-captcha.component.html',
  styleUrls: ['./china-captcha.component.css']
})
export class ChinaCaptchaComponent implements OnInit {

  @Output() chinaCaptchaStatus = new EventEmitter<string>();
  constructor() { }

  ngOnInit() {
    this.enableChinaCaptcha();
  }

  enableChinaCaptcha(): void {
    let chinaCaptchaStatusObj = this.chinaCaptchaStatus;
    document.addEventListener("DOMContentLoaded", function() {
      const _body = <HTMLElement>document.body;
      _body.scrollTop; //force css repaint to ensure cssom is ready

      let captcha = new $.Captcha({
          onFailure: () => chinaCaptchaStatusObj.emit('error'),
          onSuccess: () => chinaCaptchaStatusObj.emit('success'),
      });
      captcha.generate();
    });
  }

}
